import { documentUrl } from "../../utils/api-path";
import { logApiCall } from "../../utils/ApiLogger";
import { BaseClient } from "../baseClient";
import { IDocumentApi } from "../document-v2";

const bestandsUrl = (id: string, hoofddocumentId?: string) =>
  process.env.REACT_APP_OAS_V2 === "true"
    ? documentUrl(process.env.REACT_APP_DOCUMENT_API_ENDPOINT_V2 as string, id, hoofddocumentId)
    : `${process.env.REACT_APP_DOCUMENT_API_ENDPOINT}/documenten/${id}`;

export class MockDocumentApi extends BaseClient implements IDocumentApi {
  constructor() {
    super(
      new Headers({
        "Content-type": "application/json",
      }),
      process.env.REACT_APP_DOCUMENT_API_ENDPOINT as string
    );
  }

  uploadDocument(locationHeader: string, file: File): Promise<any> {
    logApiCall("POST", locationHeader, { document: file.name });

    return Promise.resolve({ response: new Response() });
  }

  updateDocument(id: string, file: File, redenId: string, hoofddocumentId: string): Promise<any> {
    logApiCall("PUT", bestandsUrl(id, hoofddocumentId), { document: file.name, "x-reason": redenId });

    return Promise.resolve({ response: new Response() });
  }

  async depubliceerSession(id: string, redenId: string): Promise<{ response: Response; json?: Document | undefined }> {
    logApiCall("DELETE", `${process.env.REACT_APP_DOCUMENT_API_ENDPOINT}/documenten/${id}`, { "x-reason": redenId });
    return Promise.resolve({ response: new Response() });
  }
}
